module.exports = __webpack_public_path__ + "assets/cadence.dc012968.png";